import { useContext } from 'react';
import SessionContext from '@/utils/context/SessionContext';

const useSession = () => {
  return useContext(SessionContext);
};

export default useSession;
